import { useMutation } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import createCustomSIPHeader from 'API/CustomSIPHeaders/createCustomSIPHeader';

const useCreateCustomSIPHeader = (formData, resetToMainTable) => {
    const { currentScope } = useSelector((state) => state.login);

    return useMutation({
        mutationFn: async () => {
            try {
                const data = await createCustomSIPHeader(
                    formData,
                    currentScope,
                ).then((res) => {
                    toast.success('Custom SIP Header created successfully');
                    resetToMainTable();
                    return res;
                });
                return data;
            } catch (error) {
                console.error('Error creating custom SIP header:', error);
                toast.error('Failed to create custom SIP header');
                throw error;
            }
        },
    });
};

export default useCreateCustomSIPHeader;
